import {
  useCurrentCartQuery,
  CurrentCartQuery
} from 'queries/types/CurrentCartQuery'

type Result = {
  loading: boolean
  cart: NonNullable<CurrentCartQuery['currentCart']> | null
  refetch: () => void
}

type Args = {
  skip: boolean
}

export default function useCart({ skip }: Args = { skip: false }): Result {
  const { loading, data, refetch } = useCurrentCartQuery({
    fetchPolicy: 'cache-first',
    skip
  })
  return {
    loading,
    cart: data?.currentCart || null,
    refetch
  }
}
